import { FC } from 'react'
import styled from 'styled-components'

import { getProjectName } from '../../lib/get-project-name'
import { useCarDetailsCardConfig } from '../../stages/car-details'

export type Props = {
  property?: string | React.ReactElement
  value: string | React.ReactElement
}

export const DottedPropertyValue: FC<Props> = ({ property, value }) => {
  const { detailBackground } = useCarDetailsCardConfig()
  return (
    <>
      <PropertyWrapper>
        <Property bg={detailBackground}>{property}</Property>
      </PropertyWrapper>
      <Value bg={detailBackground}>{value}</Value>
    </>
  )
}

const PropertyWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  margin: 0;
  padding-right: ${({ theme }) => theme.spacing[1]};

  &:before {
    content: '';
    position: absolute;
    bottom: 6px;
    left: 0;
    z-index: 0;
    display: block;
    width: 100%;
    border-bottom: ${({ theme }) => `1px dotted ${theme.palette.grey[500]}`};
  }
`

const Property = styled.span<{ bg: string }>`
  padding-right: 5px;
  position: relative;
  background: ${({ theme, bg }) => {
    if (bg === 'gray10') return '#f8f8f8'
    if (bg === 'gray2') return '#252c2c'
    return theme.palette.white
  }};
  color: ${({ theme }) => {
    if (getProjectName() === 'tank') return theme.palette.white
    return
  }};
  ${({ theme }) =>
    getProjectName() === 'generic_v2' &&
    `
      background: #0f0f0f;
      color: ${theme.palette.grey[100]}
    `}
`

const Value = styled.div<{ bg: string }>`
  margin: auto 0 0 0;
  padding-left: ${({ theme }) => theme.spacing[1]};
  background: ${({ theme, bg }) => {
    if (bg === 'gray10') return '#f8f8f8'
    if (bg === 'gray2') return '#252c2c'
    return theme.palette.white
  }};
  text-align: right;
  max-width: 65%;
  color: ${({ theme }) => {
    if (getProjectName() === 'tank') return theme.palette.grey[500]
    return
  }};

  ${({ theme }) =>
    getProjectName() === 'generic_v2' &&
    `
      background: #0f0f0f;
      color: ${theme.palette.grey[100]} !important;
    `}

  p {
    color: ${({ theme }) => {
      if (getProjectName() === 'tank') return theme.palette.grey[500]
      return
    }};
  }
`
